export default __webpack_public_path__ + "static/media/Mous.126efef1.svg";